import { createSelector } from '@reduxjs/toolkit';

import { RootState } from 'store/reducers';
import { SessionState } from 'store/slices/session';

export const sessionSelector = (state: RootState) => state.session;

export const otpCountdownTimeSelector = createSelector<RootState, SessionState, string>(
  state => sessionSelector(state),
  session => session.otpCountdownTime
);

export const fingerprintSelector = createSelector<RootState, SessionState, string>(
  state => sessionSelector(state),
  session => session.fingerprint
);
